
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <Header />
      
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20">
        <div className="bg-gray-900 rounded-2xl border border-gray-800 p-8 lg:p-12">
          <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
            Terms of Service – Prismatics AI
          </h1>
          
          <div className="space-y-8 text-gray-300 leading-relaxed">
            <div>
              <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
              <p>
                Welcome to Prismatics AI. By accessing or using our website and services, you agree to these Terms of Service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">2. Use of Services</h2>
              <p>
                Our platform is provided on a beta basis. You agree not to misuse the services, attempt unauthorized access, or use them for unlawful purposes.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">3. Data & Privacy</h2>
              <p>
                We respect your privacy. Data shared with us is used only for service delivery and improvement. See our Privacy Policy for details.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">4. Intellectual Property</h2>
              <p>
                All content, trademarks, and technology on this site are owned by Prismatics AI. You may not copy or reuse without permission.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">5. Limitation of Liability</h2>
              <p>
                Our services are provided "as is." Prismatics AI is not liable for any direct, indirect, or incidental damages arising from the use of our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">6. Modifications</h2>
              <p>
                We may update these Terms of Service at any time. Continued use of our services means you accept the changes.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4">7. Governing Law</h2>
              <p>
                These terms are governed by the laws of India.
              </p>
            </div>

            <div className="pt-8 border-t border-gray-800">
              <p className="text-sm text-gray-400">
                For questions about these terms, please contact us at{' '}
                <a href="mailto:reach@prismatics-ai.com" className="text-blue-400 hover:text-blue-300 cursor-pointer">
                  reach@prismatics-ai.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
